import { render, staticRenderFns } from "./CreateClaimFlow.vue?vue&type=template&id=eb71cad8&scoped=true&"
import script from "./CreateClaimFlow.vue?vue&type=script&lang=ts&"
export * from "./CreateClaimFlow.vue?vue&type=script&lang=ts&"
import style0 from "./CreateClaimFlow.vue?vue&type=style&index=0&id=eb71cad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb71cad8",
  null
  
)

export default component.exports